export const states_index = ['states.index']
export const states_create = ['states.create']
export const states_edit = ['states.edit']

export default [].concat(
    states_index,
    states_create,
    states_edit
)
